export type { CalendarData } from './calendar-data.model';
export * from './campaign';
export * from './image-source.model';
export * from './locations.const';
export * from './profile-summary';
export * from './profiles';
export * from './promoted-status.types';
export * from './property-type.types';
export * from './review-statuses.types';
export { VerticalRouteType } from './vertical-type.const';
export * from './video.types';

export interface PagedFilter {
  skip?: number;
  take?: number;
}

export const DefaultPageSize = 12;
export const DefaultPropertyPageSize = 21;
export const MaxPagedResults = 10000;

export interface PagedList<T> {
  results: T[];
  skip: number;
  take: number;
  total: number;
}

export interface FilteredPagedList<T> extends PagedList<T> {
  filters?: Record<string, FilterAggregate>;
}

export interface FilterAggregate {
  id: string;
  name: string;
  total: number;
}

export interface Option<T> {
  value: T;
  label: string;
}

export interface LocationFilters {
  cityIds?: number[];
  countyIds?: number[];
  localityIds?: number[];
  neighbourhoodIds?: number[];
  stateIds?: number[];
}
